import sideBarVsa from '../FackApi/json/SideBar.json'
import sideBarBdm from '../FackApi/json/SideBarBDM.json'



export const states = [
  {"name":"New South Wales", "code":"NSW"},
  {"name":"Queensland", "code":"QLD"},
  {"name":"South Australia", "code":"SA"},
  {"name":"Tasmania", "code":"TAS"},
  {"name":"Victoria", "code":"VIC"},
  {"name":"Western Australia", "code":"WA"},
  {"name":"Northern Territory", "code":"NT"},
  {"name":"Australian Capital Territory", "code":"ACT"}
]

export const dealerBrokerageList = [
  {"text":"0", "value":"0.00"},
  {"text":"1", "value":"0.01"},
  {"text":"2", "value":"0.02"},
  {"text":"3", "value":"0.03"},
  {"text":"4", "value":"0.04"},
  {"text":"5", "value":"0.05"},
]

export const referredLeadCommissionList = [
  {"text":"0", "value":"0.00"},
  {"text":"1", "value":"0.01"},
  {"text":"2", "value":"0.02"},
  {"text":"3", "value":"0.03"},
]

export const needToCompeteOptionVSA=[
  {"text":"0", "value":"0.00"},
  {"text":"1", "value":"0.01"},
  {"text":"2", "value":"0.02"},
  {"text":"3", "value":"0.03"},
  {"text":"4", "value":"0.04"},
  {"text":"5", "value":"0.05"},
]

export const optionTitle = [
  { text: 'Mr', value: 'Mr' },
  { text: 'Mrs', value: 'Mrs' },
  { text: 'Ms', value: 'Ms' },
  { text: 'Miss', value: 'Miss' },
  { text: 'Dr', value: 'Dr' },
  { text: 'Professor', value: 'Professor' }
]

export const optionGender = [
  { text: 'Male', value: 'Male' },
  { text: 'Female', value: 'Female' },
  { text: 'Other', value: 'Other' }
]

export const optionMaritalStatus= [
  { text: 'Single', value: 'Single' },
  { text: 'Married', value: 'Married' },
  { text: 'Defacto', value: 'Defacto' }
]

export const optionVCondition = [
  { text: 'New', value: 'N' },
  { text: 'Used', value: 'U' },
  { text: 'Demo', value: 'D' }
]

export const anotherNameOptionYesNo = [
  { text: 'Yes', value: 'Yes' },
  { text: 'No', value: 'No' }
]

export const optionCitizenOfAnotherCountryYesNo = [
  { text: 'Yes', value: 'Yes' },
  { text: 'No', value: 'No' }
]

export const optionPostalAddressAndHomeAddressAreSameYesNo = [
  { text: 'Yes', value: 'Yes' },
  { text: 'No', value: 'No' }
]

export const optionDocType = [
  { text: 'VSA', value: 11 },
  { text: 'Dealer', value: 10 }
]

export const optionThereIsAMortgageYesNo = [
  { text: 'Yes', value: 'Yes' },
  { text: 'No', value: 'No' }
]

export const optionStatus = [
  { value: 1, text: 'Draft' },
  { value: 2, text: 'New Deal' },
  { value: 13, text: 'Pending Application' },
  { value: 3, text: 'Amended Deal' },
  { value: 4, text: 'Processing' },
  { value: 5, text: 'Approved' },
  { value: 14, text: 'Preparing Docs' },
  { value: 9, text: `Doc's To Client` },
  { value: 10, text: `Doc's To Employer` },
  { value: 11, text: `Doc's to Settlement` },
  { value: 12, text: 'Pending Delivery' },
  { value: 6, text: 'Settled' },
  { value: 7, text: 'Archived' },
  { value: 8, text: 'Can not assist' }
]

export const optionLeadsStatus = [
  { value: 21, text: 'Lead' },
  { value: 22, text: 'Lead quoted' },
  { value: 23, text: 'Submitted' },
  { value: 25, text: 'LMTCB 1' },
  { value: 26, text: 'LMTCB 2' },
  { value: 27, text: 'LMTCB 3' },
  { value: 30, text: "Requ. DOCs for App" },
  { value: 31, text: "Booked Info Session" },
  { value: 28, text: "Infor. Only(Employee)" },
  { value: 32, text: "Infor. Only(Employer)" },
  { value: 24, text: 'Can not Assist' },
  { value: 29, text: 'Archived' },
]

export const optionLeadsAndQuoteStatus = [
  { value: 2, text: 'Submitted' },
  { value: 13, text: 'Pending Application' },
  { value: 3, text: 'Amended Deal' },
  { value: 4, text: 'Processing' },
  { value: 5, text: 'Approved' },
  { value: 14, text: 'Preparing Docs' },
  { value: 9, text: "Doc's To Client" },
  { value: 10, text: "Doc's To Employer" },
  { value: 11, text: "Doc's to Settlement" },
  { value: 12, text: 'Pending Delivery' },
  { value: 6, text: 'Settled' },
  { value: 21, text: 'Lead' },
  { value: 22, text: 'Lead quoted' },
  { value: 25, text: 'LMTCB 1' },
  { value: 26, text: 'LMTCB 2' },
  { value: 27, text: 'LMTCB 3' },
  { value: 30, text: 'Requ. DOCs for App' },
  { value: 31, text: 'Booked Info Session' },
  { value: 28, text: `Infor. Only(Employee)` },
  { value: 32, text: "Infor. Only(Employer)" },
  { value: 24, text: 'Can not Assist' },
  { value: 29, text: 'Archived' },
]

/**
 * User Profile settings options
 * This is going to extracted form
 * ../FackApi/json/SideBar.json
 * ../FackApi/json/SideBarBdm.json
 */
export function getSideBarItems(role_id){
  if(role_id == 1 || role_id == 2){
    return sideBarVsa || []
  }

  if(role_id == 3){
    return sideBarBdm || []
  }
}

export const maxBrokerageOptions =  [
  { id: 1, text: '1' },
  { id: 2, text: '2' },
  { id: 3, text: '3' },
  { id: 4, text: '4' },
  { id: 5, text: '5' },
  { id: 6, text: '6' },
  { id: 7, text: '7' },
  { id: 8, text: '8' },
  { id: 9, text: '9' },
  { id: 10, text: '10' }
]


export const roleOptions =  [
  { id: 1, text: 'Admin' },
  { id: 2, text: 'VSA staff' },
  { id: 3, text: 'BDM' },
  { id: 4, text: 'Dealer staff' },
  { id: 5, text: 'Referral partner' }
]

export const optionStates = [
  { item: 'SA', name: 'South Australia' },
  { item: 'NSW', name: 'New South Wales' },
  { item: 'QLD', name: 'Queensland' },
  { item: 'TAS', name: 'Tasmania' },
  { item: 'VIC', name: 'Victoria' },
  { item: 'WA', name: 'Western Australia' },
  { item: 'NT', name: 'Northern Territory' },
  { item: 'ACT', name: 'Australian Capital Territory' }
]
export const optionsPayCycle= [
  { item: 'Weekly', name: 'Weekly' },
  { item: 'Fortnightly', name: 'Fortnightly' },
  { item: 'Monthly', name: 'Monthly' },
  { item: 'Bi-Monthly', name: 'Bi-Monthly' }
]
export const optionFbtStatus= [
  { item: 'Full', name: 'Full' },
  { item: 'Rebatable', name: 'Rebatable' },
  { item: 'PBI', name: 'PBI' }
]

/**
 * List of email template category
 */
export const emailTemplateCategory =  [
  { id: 1, text: 'Leads Status' },
  { id: 2, text: 'Quote Status' },
  { id: 3, text: 'Marketing' },
]
